var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{ name: 'Console' }}},[_c('img',{attrs:{"src":require("@/assets/icons/logo.png")}}),_c('h1',[_vm._v("徽辰管理系统")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }